import React from "react";
import { Link } from "gatsby";
import Layout from "../components/layout";
import { FiPlus } from "react-icons/fi";
import styled from "styled-components";
import { rhythm } from "../utils/typography";
import { BaseButton } from "../components/button";

const StyledButton = styled(BaseButton)`
  padding: 1em 3em;
  letter-spacing: ${rhythm(0.15)};
`;

const Home = () => {
  return (
    <Layout>
      <h1>Welcome to Nehw!</h1>

      <Link to="/poll/create">
        <StyledButton>
          <FiPlus /> NEW POLL
        </StyledButton>
      </Link>
    </Layout>
  );
};

export default Home;
